import "./Memberships.css";
import DashboardLayout from "../../layouts/DashboardLayout";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { getPlans, deletePlan } from "../../services/membershipService";

export default function Memberships() {
  const navigate = useNavigate();

  const [plans, setPlans] = useState([]);

  useEffect(() => {
    loadPlans();
  }, []);

  const loadPlans = async () => {
    const data = await getPlans();

    console.log("Plans Data:", data);

    setPlans(data);
  };

  const handleDelete = async (id) => {
    await deletePlan(id);

    loadPlans();
  };

  return (
    <DashboardLayout>
      <div className="membership-page">
        <div className="membership-header">
          <div>
            <h1>Membership Plans</h1>
            <p style={{ fontWeight: "bold", color: "white" }}>
              Create and manage gym membership plans and pricing.
            </p>
          </div>

          <button
            className="add-btn"
            onClick={() => navigate("/memberships/add")}
          >
            + Add Plan
          </button>
        </div>

        <div className="membership-table-card">
          <table className="member-table">
            <thead>
              <tr>
                <th>Plan</th>
                <th>Duration</th>
                <th>Price</th>
                <th>Actions</th>
              </tr>
            </thead>

            <tbody>
              {plans.length > 0 ? (
                plans.map((plan) => (
                  <tr key={plan.id}>
                    <td>
                      <span className="plan-badge">{plan.planName}</span>
                    </td>

                    <td>{plan.duration} Days</td>

                    <td className="price-cell">₹{plan.price}</td>

                    <td>
                      <button
                        className="delete-btn"
                        onClick={() => handleDelete(plan.id)}
                      >
                        Delete
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="4">No Membership Plans Found</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </DashboardLayout>
  );
}
